"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var mock_organization_1 = require("../organizations/mock-organization");
exports.PROJECT = {
    id: '00000000-0000-0000-0000-000000000001',
    name: 'Project Title',
    customerOrganization: mock_organization_1.ORGANIZATION,
    poNumber: '1234'
};
